import UserAgent from './user-agent';


module.exports = UserAgent;
